import { changeProp } from 'modules/storeSlice';
import { useDispatch, useSelector } from 'react-redux';

const usePlaceSelector = () => {
  const dispatch = useDispatch();

  const { floor } = useSelector(({ store }) => store.spaceRegisterForm);

  const onSelect = e => {
    e.stopPropagation();
    dispatch(
      changeProp({
        obj: 'spaceRegisterForm',
        key: 'floor',
        value: e.target.innerHTML,
      }),
    );
  };

  return { floor, onSelect };
};

export default usePlaceSelector;
